import {useCallback, useEffect, useState} from "react";
import PropTypes from "prop-types";
import "./LimitedCharactersDialog.css";
import GenericDialog from "components/ui/dialogs/generic-dialog/GenericDialog";
import {Button, Grid, Typography} from "@material-ui/core";
import RichiestaInviataDialog from "../richiesta-inviata-dialog/RichiestaInviataDialog";
import LimitedCharactersInput from "components/ui/inputs/limited-characters-input/LimitedCharactersInput";
import * as actions from "../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {createNote, simsToIccIdAndMsisdnList} from "../../../utils/utils";
import ButtonWithProgress from "../../../../components/ui/buttons/button-with-progress/ButtonWithProgress";

const LimitedCharactersDialog = ({handleDialogClose, ...props}) => {
    const [limitedCharactersText, setLimitedCharactersText] = useState("");
    const [openRichiestaInviata, setOpenRichiestaInviata] = useState(false);
    const userClaims = useSelector(state => state.authReducer.userClaims)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading)
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error)
    const activeServiceRequest = useSelector(state => state.simReducer.activeServiceRequest)
    const dispatch = useDispatch();

    const textChanged = (text) => {
        setLimitedCharactersText(text);
    };

    const closeDialog = useCallback(() => {
        setLimitedCharactersText("");
        handleDialogClose();
    }, [handleDialogClose])

    useEffect(() => {
        if (props.checkActiveSr) {
            if (activeServiceRequest.value) {
                closeDialog();
            }
        }
    }, [activeServiceRequest.value, closeDialog, props.checkActiveSr])

    const handleRichiestaInviataButton = () => {
        closeDialog()
        setOpenRichiestaInviata(false);
    }

    const handleRichiestaCloseButton = () => {
        closeDialog()
        setOpenRichiestaInviata(false);
    }

    const handleSubmitForm = () => {
        let simIccIdList = simsToIccIdAndMsisdnList(props.sims);
        const note = createNote(limitedCharactersText);
        dispatch(actions.submitReportInSegnalazione(
            selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId,
            props.screenCode,
            userClaims.uid,
            "",
            "",
            "",
            limitedCharactersText,
            "",
            simIccIdList,
            note
        ));
        setOpenRichiestaInviata(true);
    }

    const dialogContent = (
        <>
            <Typography variant="h5">{props.title}</Typography>
            <Typography className="pb-20" variant="body2">
                {props.subtitle}
            </Typography>
            <Grid container className="mt-35">
                <Grid item xs={12} md={3}>
                    <Typography className="my-12" variant="subtitle2">
                        Dettaglio richiesta
                    </Typography>
                </Grid>
                <Grid item xs={12} md={9}>
                    <LimitedCharactersInput label={"Descrivi qui la tua richiesta"} textChanged={textChanged}
                                            characterLimit={props.characterLimit}/>
                </Grid>
            </Grid>
            {openRichiestaInviata && !loadingReportProblem && !errorReportProblem ? (
                <RichiestaInviataDialog
                    open={openRichiestaInviata}
                    handleDialogClose={handleRichiestaInviataButton}
                    handleRichiestaCloseButton={handleRichiestaCloseButton}
                />
            ) : null}
        </>
    );

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button onClick={closeDialog} color="primary" variant="outlined">
                <div className="align-center-x px-16">Annulla</div>
            </Button>

            <ButtonWithProgress handleClick={handleSubmitForm}
                                text={"Invia"}
                                disabled={limitedCharactersText.length === 0 || limitedCharactersText.length >= props.characterLimit}
                                loading={loadingReportProblem}/>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={closeDialog}
            handleDialogCloseButton={closeDialog}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            loading={props.checkActiveSr ? activeServiceRequest.loading : null}
        />
    );
};
LimitedCharactersDialog.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    open: PropTypes.bool,
    sims: PropTypes.array,
    screenCode: PropTypes.string,
    checkActiveSr: PropTypes.bool
};

LimitedCharactersDialog.defaultProps = {
    sims: [],
    checkActiveSr: false
};


export default LimitedCharactersDialog;
